// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"71cafa32","262":"34e2cd70","478":"314600ed","722":"51981bb3","926":"3bc92af6"}[chunkId] + ".chunk.css";
};